import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Container } from '@material-ui/core';
import { decrypted } from '../../../util/CryptoUtil'

import CardPerfil from './Candidato/CardPerfil';
import ListaVagas from './Candidato/ListaVagas';
import VagasAplicadas from './Candidato/VagasAplicadas';

import { getAddress } from '../../../serviceAPI/getAddress'
import { getOpportunityByUser } from '../../../serviceAPI/opportunity/getOpportunityByUser';
import { getProfessionalProfile } from '../../../serviceAPI/professionalProfile/getProfessionalProfile';
import { getPhotoProfile } from '../../../serviceAPI/fotoPerfil/getPhotoProfile';

export default function DashCandidato() {
  const dispatch = useDispatch();
  const endereco = useSelector(state => state.endereco)
  const vagas = useSelector(state => state.opportunity.opportunities)
  const fotoPerfil = useSelector(state => state.fotoPerfil)

  const userEncrypt = localStorage.getItem(process.env.REACT_APP_USER)
  const userDecrypt = decrypted(userEncrypt)
  const user = JSON.parse(userDecrypt)

  const professionalProfile = useSelector(state => state.professionalProfile)
  const perfil = professionalProfile.professionalProfile


  const detalhesPerfil = {
    'fotoCapa': 'https://cdn.discordapp.com/attachments/768449017867796521/771071766490644500/capa_linkedin_iti.jpg',
    'fotoPerfil': fotoPerfil.uri,
    'nomeCandidato': user ? `${user.first_name} ${user.last_name}` : "",
    'tituloCandidato': perfil ? `${perfil.title}` : "",
    'cidadeCandidato': endereco ? endereco.localidade : "",
    'ufCandidato': endereco ? endereco.uf : "",
    'descricaoCandidato': perfil ? `${perfil.description}` : "",
    'skillsCanditado': perfil ? `${perfil.skills}` : "",
  }

  React.useEffect(() => {
    getAddress(dispatch);
    getOpportunityByUser(dispatch);
    getProfessionalProfile(dispatch);
    getPhotoProfile(dispatch);
  }, [dispatch]);

  return (
    <div style={{ paddingTop: 20 }}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <CardPerfil detalhesPerfil={detalhesPerfil} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListaVagas detalhesVagas={vagas} />
          </Grid>
          <Grid item xs={12} md={2}>
            <VagasAplicadas detalhesVagasAplicadas={vagas.length} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}